<div *ngIf="town" [class.d-none]="!childActive" [class.detail-overlay]="!screenshot" [class.workarea]="childIsWorkarea">
    <router-outlet (activate)="childActivate();childChanged($event)" (deactivate)="childDeactivate()"></router-outlet>
</div>
<app-workareas-map *ngIf="!hideMap && town && (!childActive || !screenshot) && town.id > 0" [class.d-none]="childActive"></app-workareas-map>

